<template>
  <div class="d-flex justify-content-around h-100 w-100 mobile-nav-item-container">
    <router-link
        v-slot="{ href, route, navigate, isActive, isExactActive }"
        :to="{ name: 'Welcome', params: { uuid: id } }"
    >
      <div
          :class="[isActive && 'active', isExactActive && 'exact-active']"
          class="mobile-nav-item"
          @click="navigate"
      >
        <div class="mobile-nav-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="30" viewBox="0 0 25 21" fill="none">
            <path d="M19.5 11.6013V15.6666C19.5 16.6808 19.1399 17.548 18.4197 18.2682C17.6996 18.9883 16.8324 19.3484 15.8182 19.3484H5.18182C4.16761 19.3484 3.30043 18.9883 2.58026 18.2682C1.86009 17.548 1.5 16.6808 1.5 15.6666V5.03024C1.5 4.01603 1.86009 3.14885 2.58026 2.42867C3.30043 1.7085 4.16761 1.34842 5.18182 1.34842H15.8182C16.3551 1.34842 16.8537 1.45495 17.3139 1.66802C17.4418 1.72768 17.5185 1.82569 17.544 1.96206C17.5696 2.10694 17.5312 2.23052 17.429 2.33279L16.8026 2.95921C16.7173 3.04444 16.6193 3.08706 16.5085 3.08706C16.483 3.08706 16.4446 3.07853 16.3935 3.06149C16.1974 3.01035 16.0057 2.98478 15.8182 2.98478H5.18182C4.61932 2.98478 4.13778 3.18507 3.73722 3.58564C3.33665 3.9862 3.13636 4.46774 3.13636 5.03024V15.6666C3.13636 16.2291 3.33665 16.7106 3.73722 17.1112C4.13778 17.5118 4.61932 17.7121 5.18182 17.7121H15.8182C16.3807 17.7121 16.8622 17.5118 17.2628 17.1112C17.6634 16.7106 17.8636 16.2291 17.8636 15.6666V12.4194C17.8636 12.3086 17.902 12.2149 17.9787 12.1382L18.7969 11.32C18.8821 11.2348 18.9801 11.1922 19.0909 11.1922C19.142 11.1922 19.1932 11.205 19.2443 11.2305C19.4148 11.2987 19.5 11.4223 19.5 11.6013ZM22.4531 5.34984L12.0469 15.7561C11.8423 15.9606 11.5994 16.0629 11.3182 16.0629C11.0369 16.0629 10.794 15.9606 10.5895 15.7561L5.09233 10.2589C4.88778 10.0544 4.78551 9.81149 4.78551 9.53024C4.78551 9.24899 4.88778 9.00609 5.09233 8.80154L6.49858 7.39529C6.70312 7.19075 6.94602 7.08848 7.22727 7.08848C7.50852 7.08848 7.75142 7.19075 7.95597 7.39529L11.3182 10.7575L19.5895 2.4862C19.794 2.28166 20.0369 2.17939 20.3182 2.17939C20.5994 2.17939 20.8423 2.28166 21.0469 2.4862L22.4531 3.89245C22.6577 4.097 22.7599 4.3399 22.7599 4.62115C22.7599 4.9024 22.6577 5.14529 22.4531 5.34984Z" fill="#2E2E2E"/>
          </svg>
        </div>
        <div>{{ translate('Result') }}</div>
      </div>
    </router-link>
    <router-link
        v-slot="{ href, route, navigate, isActive, isExactActive }"
        :to="{ name: 'FileList', params: { uuid: id } }"
    >
      <div
          :class="[isActive && 'active', isExactActive && 'exact-active']"
          class="mobile-nav-item"
          @click="navigate"
      >
        <div class="mobile-nav-icon">
          <i class="far fa-list fa-2x"></i>
        </div>
        <div>{{ translate('Files') }}</div>
      </div>
    </router-link>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin';
import currentJob from './../../mixins/current_job.mixin';

export default {
  name: 'MobileNavbar',
  props: {},
  components: {},
  mixins: [store, currentJob],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {},
};
</script>
<style lang="scss">
.mobile-nav-item-container {
  gap: 0px;
  align-items: stretch;
  justify-content: center;
}

.mobile-nav-item {
  height: 100%;
  align-items: center;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: black;
  justify-content: center;

  &.active {
    background: #CBCBCB;
  }

  .mobile-nav-icon {
    height: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
</style>
